<template>
  <v-container class="c-claims app-bg">
    <v-layout column >
      <p v-html="value"></p>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  props: {
    value: String,
  },
};
</script>

<style lang="scss" scoped>
.c-claims {
  h3 {
    margin: 20px 0 5px;
  }
  img {
    width: 800px;
  }
}
</style>
